var map = {
	"./dark/sport/07sportIndex/01best.png": "obPt",
	"./light/sport/07sportIndex/01best.png": "W72q"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ALqU";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme ^\.\/.*\/sport\/07sportIndex\/01best\.png$
// module id = ALqU
// module chunks = 0